<template>
  <div class="input-group">
    <span class="input-group-text">
      <i class="fa fa-search"></i>
    </span>
    <input :value="search" @input="$emit('update:search', $event.target.value)" type="text" class="form-control"
      placeholder="Buscar evento por título..." />
  </div>
</template>

<script setup>
defineProps({
  search: {
    type: String,
    default: ''
  }
});

</script>
